
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://api18081113.sayq.pl";

export default function AdminAuth() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError("Wpisz email i hasło");
            return;
        }

        try {
            const res = await fetch(`${API}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });
            const data = await res.json();
            if (res.ok && data.success) {
                localStorage.setItem("authToken", "admin-logged-in");
                localStorage.setItem("secretId", data.secretId);
                navigate("/admin-panel");
            } else {
                setError(data.error || "Błąd logowania");
            }
        } catch (err) {
            console.error(err);
            setError("Błąd połączenia z serwerem");
        }
    };

    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light p-3">
            <div className="card shadow-sm border-0 rounded-4 w-100 p-4" style={{ maxWidth: 400 }}>
                <h3 className="text-center mb-4 fw-bold">Logowanie - Organizator</h3>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label text-secondary small fw-bold">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email} onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="form-label text-secondary small fw-bold">Hasło</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password} onChange={e => setPassword(e.target.value)}
                        />
                    </div>

                    {error && <div className="text-danger text-center small fw-bold mb-3">{error}</div>}

                    <button type="submit" className="btn btn-primary w-100 rounded-pill py-2 fw-bold shadow-sm">
                        Zaloguj się
                    </button>
                </form>
            </div>
        </div>
    );
}
